import { PREFIX } from '../../util/config'
import { parseUnit, parseString } from '../../util/index'
import ColumnManager from '../../util/column-manager'
import { TableProps } from '../../util/default-props'
import Empty from '../empty/index'
import Scroll from '../scroll'
import resizeObserverMixin from '../../mixin/resize-observer'
import '../index.scss'
import TableTbody from './table-tbody'
import ColGroup from './col-group'
import createSticky from '../scroll/sticky'
import { isFunction } from 'lodash'

// 基础表格
export default {
  name: 'SyTable',
  provide () {
    return { table: this }
  },
  mixins: [resizeObserverMixin],
  props: { 
    ...TableProps,
    expandRows: [],
    customSlots: [Object],
    expandColumn: [Object]
  },
  computed: {
    className () {
      let className = `${PREFIX}`
      if (this.border) {
        className += ` ${PREFIX}-border`
      }
      if (this.isScrollX) {
        className += ` ${PREFIX}-left-scroll`
      }
      return className
    },
    bodyHeight () {
      return parseUnit(this.height || this.maxHeight)
    }
  },
  data () {
    return {
      // expandRows: [],
      scorllPos: 'left-scroll', // 滚动条位置
      bodyWidth: 0,
      boxReadWidth: 0,
      isScrollX: false, // 是否需要横行滚筒条
      computeFinish: false // 第一遍渲染只渲染表头
    }
  },
  created () {
    this.curRefs = Object.create(null)
    this.columnManager = new ColumnManager(this.columns)
    this.prefix = PREFIX
    // 吸顶模式
    if (this.sticky) {
      this.$watch('computeFinish', (val) => {
        if (val) {
          this.$nextTick(() => {
            this.stickyBodyHeader = createSticky({
              fixEl: this.$refs.stickyHeader,
              referEl: this.$el,
              warpEl: this.$refs.tableWarp,
              scrollFn: ({isFixed, fixEl}) => {
                if (isFixed) {
                  fixEl.style.overflow = 'auto'
                  fixEl.scrollLeft = this.lastScrollLeft
                } else {
                  fixEl.style.overflow = 'visible'
                }
                this.isFiexdBodyHeader = isFixed
              },
              clearFixFn: ({fixEl}) => {
                fixEl.style.overflow = 'auto'
              }
            })
          })
        }
      })
    }
    this.$watch('columns', (val) => {
      this.columnManager.resetColumns(val)
      this.updateWidth()
      this.$forceUpdate()
    })
  },
  mounted () {
    // TODO 监听宽度的变化
    this.createdResizeObserver((entry) => {
      if (!this.$ready) { return }
      let width = this.columnManager.columnsWidth()
      if (entry.contentRect.width !== 0 && entry.contentRect.width !== width) {
        this.updateWidth()
      }
    })
    this.$ready = true
    this.boxReadWidth = this.$el.offsetWidth - 2
  },
  updated () {
    // this.updateWidth()
  },
  methods: {
    
    // 更新宽度
    updateWidth () {
      // 获取当前盒宽度  -2是为了去除边框
      this.layoutWidth = this.$el.getBoundingClientRect().width - 2
      // 重置之后table 真实内容宽度
      const columnsWidth = this.columnManager.columnsWidth()
      const _width = Math.max(columnsWidth, this.layoutWidth)
      if (_width === this.bodyWidth) return
      this.isScrollX = columnsWidth > this.layoutWidth
      // 重置宽度
      this.columnManager.resetColumnsWidth(this.isScrollX)
      this.computeFinish = true
      this.bodyWidth = _width
    },
    // 过去当前 key
    getRowKey (record, index) {
      let key
      if (isFunction(this.rowKey)) {
        key = this.rowKey(record)
      } else {
        key = parseString(this.rowKey, record)
      }
      return key === undefined || key === '' ? index : key
    },

    // 水平滚动
    handleScroll (event) {
      const target = event.target
      // 添加class 不重新加载页面
      const scorllPos = this.scorllPos
      if (target.scrollLeft === 0) {
        this.scorllPos = 'left-scroll'
      } else if (target.scrollWidth - target.offsetWidth <= (target.scrollLeft + 1)) {
        this.scorllPos = 'right-scroll'
      } else {
        this.scorllPos = 'middle-scroll'
      }
      if (scorllPos !== this.scorllPos) {
        this.$el.classList.remove(`${PREFIX}-${scorllPos}`)
        this.$el.classList.add(`${PREFIX}-${this.scorllPos}`)
      }
      if (!this.sticky || !this.isFiexdBodyHeader) {
        this.lastScrollLeft = target.scrollLeft
        return
      }
      if (this.lastScrollLeft !== target.scrollLeft) {
        let targetEl = this.$refs.stickyHeader !== target ? this.$refs.stickyHeader : this.$refs.scrollBox.$el
        targetEl.scrollLeft = target.scrollLeft
      }
      this.lastScrollLeft = target.scrollLeft
    },

    // 渲染表格
    renderTable ({columns}) {
      return (<div class={`${PREFIX}-warp`} ref='tableWarp'>
        <table style={{width: this.bodyWidth + 'px'}} key='table'>
          {(this.computeFinish && <ColGroup columns={columns} /> )}
          {!this.sticky && this.renderThead(columns)}
          {(this.computeFinish) && <TableTbody columns={columns}/>}
        </table>
      </div>)
    },

    renderThead (columns) {
      const thTemplate = columns.map((column, colIndex) => {
        const { title, dataIndex, cellClassName, style } = column
        return (
          <th key={dataIndex} class={cellClassName} style={style}>
            <div class={`${PREFIX}-cell`}>
              {typeof title === 'function' ? title({ column, colIndex }) : title}
            </div>
          </th>
        )
      })
      return <thead class={`${PREFIX}-thead`}><tr>{thTemplate}</tr></thead>
    },

    // 暂无数据
    renderEmpty () {
      if (this.dataSource.length || this.loading) {
        return null
      }
      return this.customSlots?.empty || <Empty />
    },

    // loading
    renderLoading () {
      if (!this.loading) {
        return null
      }
      const loadingStyle = {}
      if (this.dataSource.length > 0) {
        loadingStyle.position = 'absolute'
        loadingStyle.top = `${this.stickyColumnsHeadRowsHeight}px`
      } else {
        loadingStyle.position = ''
        loadingStyle.top = 0
      }
      return (
        <div
          v-loading={this.loading}
          class={`${PREFIX}-loading`}
          style={loadingStyle}
        ></div>
      )
    },
    // 吸顶
    renderStickyHeader ({ columns }) {
      if (!this.sticky) { return null }
      return (
        <div class='sy-table-sticky-header' style={{width: `${this.layoutWidth}px`}} ref='stickyHeader' on-scroll={this.handleScroll}>
          <table style={{width: this.bodyWidth + 'px'}}>
            {(this.computeFinish && <ColGroup columns={columns} /> )}
            {this.renderThead(columns)}
          </table>
        </div>
      )
    }
  },
  render (h) {
    const { columnManager, bodyHeight } = this
    const content = <div class={this.className}>
      <Scroll onScroll={this.handleScroll} ref='scrollBox' style={{
        maxHeight: `${bodyHeight}px`
      }}>
        {
          [
            this.renderStickyHeader({columns: columnManager.columns}),
            this.renderTable({columns: columnManager.columns}),
            this.renderEmpty(),
            this.renderLoading()
          ]
        }
      </Scroll>
    </div>
    return content
  },
  components: {
    Empty,
    ColGroup,
    TableTbody,
    Scroll
  }
}
